import EmptyRouterView from './../views/administrative/EmptyRouterView.vue'
import Administrator from './../views/administrative/Home.vue'

import DocumentHome from './../views/administrative/document/Document.vue'
import DirectoryHome from './../views/administrative/directory/Directory.vue'
import CellarHome from "./../views/administrative/cellar/Cellar.vue"
import TrashDocument from "../views/administrative/TrashDocument/TrashDocument.vue"

export const routes = [
  {
    path: '/jefatura',
    component: EmptyRouterView,
    children: [
      {
        path: '',
        name: 'administrativeHome',
        component: Administrator,
      },
      {
        path: 'documentos/:id',
        name: 'documentsAdministrative',
        component: DocumentHome,
        props: true,
        meta: {
          breadcrumb: [
            { name: 'documentos' }
          ]
        }
      },
      {
        path: 'bodegas',
        name: 'cellarsAdministrative',
        component: CellarHome,
      }, 
      {
        path: 'directorio/:id',
        name: 'directoryAdministrative',
        component: DirectoryHome,
        props: true,
        meta: {
          breadcrumb: [
            { name: 'directorio' }
          ]
        }
      },
      {
        path: 'eliminados',
        name: 'trashAdministrative',
        component: TrashDocument,
        meta: {
          breadcrumb: [
            { name: 'eliminados' }
          ]
        }
      },

    ]
  },
]